import { httpRequest } from "@/utils/HttpRequest";
import {
    ISaleSoSearch,
    ISaleSoDetail,
    ISaleSoFields,
    ISaleSoList,
    Detailed,
    IInvalidate,
    ISaleSoPoSettleAndWhConfirm,
    ISaleSoSettleParams,
    ISaleSoStatistics
} from "./saleSoTypes"

class SaleSoService {
    async page(searchVo: ISaleSoSearch) {
        const apiUrl = "/vrm2/sale/findPage";
        return await httpRequest.post<ISaleSoList>(apiUrl, searchVo);
    }
    async total(searchVo: ISaleSoSearch) {
        const apiUrl = "/vrm2/sale/total";
        return await httpRequest.post<ISaleSoStatistics>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/vrm2/sale/findById/${id}`;
        return await httpRequest.get<ISaleSoDetail>(apiUrl);
    }

    async insert(insertVo: ISaleSoFields) {
        const apiUrl = "/vrm2/sale/insert";
        return await httpRequest.post<ISaleSoDetail>(apiUrl, insertVo);
    }
    async update(updateVo: ISaleSoFields) {
        const apiUrl = "/vrm2/sale/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //明细删除
    async materialDelete(params: Detailed) {
        const apiUrl = "/vrm2/sale/materialDelete";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //导出
    async export(params: ISaleSoFields) {
        const apiUrl = "/vrm2/sale/export";
        return await httpRequest.postFile(apiUrl, params, { timeout: 300000 });
    }
    //转销售单
    async transfer(planCode: string) {
        const apiUrl = `/vrm2/sale/transfer/${planCode}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    // //详情导入
    // async invalidate(){
    //     const apiUrl = "/vrm2/sale/detail/downloadTpl";
    //     return await httpRequest.getFile<boolean>(apiUrl);
    // }
    //下载模板
    async downloadTpl() {
        const apiUrl = "/vrm2/sale/detail/downloadTpl";
        return await httpRequest.getFile<boolean>(apiUrl);
    }
    //作废
    async invalidate(params: IInvalidate) {
        const apiUrl = "/vrm2/sale/invalidate";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //库房确认
    async warehousing(params: ISaleSoPoSettleAndWhConfirm) {
        const apiUrl = "/vrm2/sale/warehousing";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //销售结算
    async settle(params: ISaleSoSettleParams) {
        const apiUrl = "/vrm2/sale/settlePro";
        // const apiUrl = "/vrm2/sale/settle";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //销售补单
    async supplementInsert(insertVo: ISaleSoFields) {
        const apiUrl = "/vrm2/sale/supplementInsert";
        return await httpRequest.post<ISaleSoDetail>(apiUrl, insertVo);
    }
    //详情导出
    async detailsExport(params: ISaleSoFields) {
        const apiUrl = "/vrm2/sale/detailsExport";
        return await httpRequest.postFile(apiUrl, params, { timeout: 300000 });
    }
    //打印次数
    async printNum(id: string) {
        const apiUrl = `/vrm2/sale/print/${id}`;
        return await httpRequest.get(apiUrl);
    }
    async someSettle(params: any) {
        const apiUrl = `/vrm2/sale/warehousingBatch`;
        return await httpRequest.post<boolean>(apiUrl, params);
    }
}

export const saleSoService = new SaleSoService();